import { Injectable } from '@angular/core';
import {
  DEFAULT_STATIC_FEATURE_FLAGS,
  StaticFeatureFlagConfig,
  StaticFeatureFlagKey,
} from './static-feature-flag-config';

@Injectable({
  providedIn: 'root',
})
export class StaticFeatureFlagService {
  private flags: StaticFeatureFlagConfig = { ...DEFAULT_STATIC_FEATURE_FLAGS };
  private initialized = false;

  init(config: Partial<StaticFeatureFlagConfig> | null | undefined): void {
    this.flags = { ...DEFAULT_STATIC_FEATURE_FLAGS, ...(config ?? {}) };
    this.initialized = true;
  }

  isInitialized(): boolean {
    return this.initialized;
  }

  isEnabled(key: StaticFeatureFlagKey): boolean {
    return this.get(key, false);
  }

  get<K extends StaticFeatureFlagKey>(
    key: K,
    fallback: StaticFeatureFlagConfig[K]
  ): StaticFeatureFlagConfig[K] {
    const value = this.flags[key];
    return value === undefined || value === null ? fallback : value;
  }

  getAll(): Readonly<StaticFeatureFlagConfig> {
    return this.flags;
  }

  setFlag<K extends StaticFeatureFlagKey>(
    key: K,
    value: StaticFeatureFlagConfig[K]
  ): void {
    this.flags = { ...this.flags, [key]: value };
  }
}
